module.exports = __webpack_public_path__ + "img/bg-poster-4.b14ff721.webp";